import BaseError from '@shared/exceptions/BaseError'

export default class WrongDataError extends BaseError {
  constructor(info: { message: string; action: string; cause?: unknown }) {
    super({
      name: WrongDataError.name,
      action: info.action,
      message: info.message,
      cause: info.cause
    })
  }
}
